import React, { useEffect } from 'react';
import { uniqueId } from 'lodash';
import { Grid } from '@material-ui/core';
import {
  StyledTabs,
  StyledTabManager,
  StyledTabLawyer,
  StyledOrangeTabs,
} from 'components/JudiciaryProcessTabs/style';
import { isCourtManager } from 'containers/AppContainer/utils';
import { isMonitoringCourtManager } from 'helpers/utils';

export interface JudiciaryProcessTabsProps {
  children?: any;
  labels: string[];
  currentTabIndex: number;
  onTabClick?: Function;
  setCurrentInstanceTab?: Function;
  onPressFeeNote?: () => void;
  handleClickVerticalTabs?: Function;
  handleClickVerticalTabsTransaction?: Function;
  isTransactionTabs?: boolean;
}

const JudiciaryProcessTabs: React.FC<JudiciaryProcessTabsProps> = (
  props,
): JSX.Element => {
  const {
    currentTabIndex,
    children,
    labels,
    onTabClick,
    handleClickVerticalTabs,
    handleClickVerticalTabsTransaction,
  } = props;
  const [currentTab, setCurrentTab] = React.useState<number>(currentTabIndex);
  useEffect(() => {
    if (onTabClick) onTabClick(currentTab);
    setCurrentTab(currentTabIndex);
    if (handleClickVerticalTabs) handleClickVerticalTabs(currentTab);
    if (handleClickVerticalTabsTransaction)
      handleClickVerticalTabsTransaction(currentTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabIndex, onTabClick]);

  const handleChangeTab = (event: React.ChangeEvent<{}>, newTab: number) => {
    if (onTabClick) onTabClick(currentTab);
    setCurrentTab(newTab);
    if (handleClickVerticalTabs) handleClickVerticalTabs(newTab);
    if (handleClickVerticalTabsTransaction)
      handleClickVerticalTabsTransaction(newTab);
  };
  const isManager = isCourtManager() || isMonitoringCourtManager();

  return (
    <Grid container direction="row">
      <Grid item xs={1}>
        <StyledTabs value={currentTab} onChange={handleChangeTab}>
          {React.Children.toArray(children).map((_, index) =>
            props.isTransactionTabs ? (
              <StyledOrangeTabs
                key={uniqueId('sahamtab')}
                label={labels[index]}
                data-testid={`vertical-${index}`}
              />
            ) : isManager ? (
              <StyledTabManager
                key={uniqueId('sahamtab')}
                label={labels[index]}
                data-testid={`vertical-${index}`}
              />
            ) : (
              <StyledTabLawyer
                key={uniqueId('sahamtab')}
                label={labels[index]}
                data-testid={`vertical-${index}`}
              />
            ),
          )}
        </StyledTabs>
      </Grid>
      <Grid item xs={11}>
        {props.isTransactionTabs ? children[currentTabIndex] : children[0]}
      </Grid>
    </Grid>
  );
};

export default JudiciaryProcessTabs;
